import { PaymentSystem } from 'mbs-ui-shared@models';
import { LicenseMode } from 'mbs-ui-shared@models/ProviderData';

export function isYearlyLicenseMode(licenseMode: LicenseMode) {
  return (
    licenseMode === LicenseMode.Yearly ||
    licenseMode === LicenseMode.CumulativeV2Annual ||
    licenseMode === LicenseMode.CumulativeV3Annual ||
    licenseMode === LicenseMode.CumulativeV4Annual
  );
}

export function isMonthlyLicenseMode(licenseMode: LicenseMode) {
  return (
    licenseMode === LicenseMode.Monthly ||
    licenseMode === LicenseMode.CumulativeV2Monthly ||
    licenseMode === LicenseMode.CumulativeV3Monthly ||
    licenseMode === LicenseMode.CumulativeV4Monthly
  );
}

export function isShareItMode(paymentSystem: PaymentSystem) {
  return paymentSystem === PaymentSystem.ShareIT;
}
